import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import './cart.scss';
import {
  showCart,
  resetCart,
  postAddItem,
  getPromoList,
  postRemoveItem,
  applyPromoCode,
  removePromoCode,
  removeSoldoutItems,
  applyReferralCode,
  removeReferralCode,
} from 'hb-redux-store/feature/cart/cart.action';
import Messages from 'components/mweb/Messages/Messages';
import ProductCard from 'components/web/ProductCard/ProductCard';
import Button from 'components/common/Button/Button';
import Input from 'components/mweb/Input/Input';
import Loader from 'components/mweb/Skeletons/Loader/Loader';
import Icon from 'components/mweb/Icon/Icon';
import { Link } from 'react-router-dom';
import { getCheckoutRoute } from '../checkout/checkout.routes';
import { initializeMap } from 'hb-redux-store/util/locationService';
import history from 'hb-redux-store/history';
import CookieService from 'hb-redux-store/util/cookieService';
import { getRandomSection } from 'hb-redux-store/feature/products/product.action';
import Deals from 'components/web/Deals/Deals';
import Drawer from 'components/common/Drawer';
import { setAppNotification } from 'hb-redux-store/initial.action';
import {
  showLoginModal,
  showAddressListModal,
  showScratchCardModal,
} from 'hb-redux-store/feature/modal/modal.action';
import AddAddress from 'components/web-feature/checkout/AddAddress';
import CartAddon from '../../common/CartAddon/CartAddon';
import AnalyticsService from '../../../AnalyticsService';
import SimpleModal from '../../mweb/Modal/SimpleModal';
import MembershipBanner from 'components/web/MembershipBanner/MembershipBanner';
import HalalboxPrime from 'feature/halalbox-prime/HalalboxPrime';
import giftIcon from 'assets/icons/gift-oval.svg';
import { convertArrayToObject } from 'hb-redux-store/util/miscellaneousServices';

import {
  WEDNESDAY_COUPONS,
  AVAILABLE_COUPONS,
  APPLY_TEXT,
} from 'hb-redux-store/feature/cart/cart.constant';
import { BUY_MEMBERSHIP } from 'hb-redux-store/constants/halalboxPrime';

// onSale: true
// onSale: false
// isPresale: true
// soldOut: true
// inCartQty: true
// inCartQty: false
const { clevertap } = AnalyticsService;

const ListComponent = ({
  list,
  isScratchCard = false,
  applyPromo = () => {},
}) => (
  <div className="desktop-promo-list">
    {list.map((item, index) => (
      <div
        className="desktop-promo-list--promo"
        key={`${index}.${item?.promoCode}`}
      >
        <div className="flex-shrink-0">
          {isScratchCard ? (
            <div className="desktop-promo-list--img-container">
              <img src={item?.iconUrl} className="desktop-promo-list--img" />
            </div>
          ) : (
            <div className="desktop-promo-list--promo--icon">
              <div className="desktop-promo-list--promo--icon-bg">
                <Icon class="icon-cart-promo-sample" size={30} />
              </div>
            </div>
          )}
        </div>
        <div className="flex-grow-1 desktop-promo-list--div">
          <div className="justify-content--space-between">
            <div className="desktop-promo-list--promo--code">
              {isScratchCard ? item?.description : item?.promoCode}
            </div>
            <Button
              className="button action-link desktop-promo-list--promo--apply-cta"
              onClick={() => applyPromo(item?.promoCode)}
            >
              {APPLY_TEXT}
            </Button>
          </div>
          <div className="desktop-promo-list--promo--description">
            <span>{isScratchCard ? item?.infoText : item?.description}</span>
            {item?.suggestion && (
              <div className="desktop-promo-list--promo--suggestion">
                {item?.suggestion}
              </div>
            )}
          </div>
        </div>
      </div>
    ))}
  </div>
);

const CartSummary = ({ summaryOrder = [], showHbPointsModal = () => {} }) => (
  <div className="desktop-cart--summary-box">
    {summaryOrder.map(detail => {
      if (!detail.amount && detail.hideEmpty) return false;
      return (
        <div
          className="desktop-cart--summary-box--item"
          style={{ color: detail.hexcolors }}
          key={detail.key}
        >
          <div className="key">
            {detail.prefixIconUrl && (
              <Icon src={detail.prefixIconUrl} size={22} />
            )}
            <span>{detail.text}</span>
            {detail.text.toLowerCase() === 'vxl points' && (
              <Icon
                class="desktop-cart--summary-box--item--info icon-referral-info-yellow"
                size={19}
                onClick={() => showHbPointsModal()}
              />
            )}
          </div>
          {detail.key === 'deliveryCharges' && (
            <div className="value">
              {detail.amount === 0 ? (
                <span>FREE</span>
              ) : (
                <span>&#8377;{detail.amount}</span>
              )}
            </div>
          )}
          {detail.key !== 'deliveryCharges' && (
            <div className="value">
              {detail.showSign ? `${detail.showSign} ` : ''}
              &#8377;
              {detail.amount}
            </div>
          )}
        </div>
      );
    })}
  </div>
);
class Cart extends React.Component {
  state = {
    showPromoInput: false,
    promoCode: '',
    showReferralInput: false,
    referralCode: '',
    invalidReferral: false,
    invalidReferralMsg: '',
    showAddressModal: false,
    showHbPointsModal: false,
    showHbPrime: false,
  };
  isLoggedInUser = () =>
    this.props.loggedInState && CookieService.isLoggedInUser();
  componentDidMount() {
    this.props.showCart({
      cb: ({ priceDetails = {} }) => {
        const gtmData = {
          eventName: 'viewCart',
          eventData: {
            category: 'view_cart',
            value: priceDetails.payableAmount || 0,
          },
        };
        const key = 'View Cart';
        const payload = {
          ...convertArrayToObject(this.props.cart.cartItems || []),
          cartItemTotalAmount:
            this.props.cart.priceDetails?.orderTotalAmount || 0,
          serviceAbleArea: this.props.launchInfo?.adcCode,
          customerType: this.props.launchInfo?.customerType,
        };
        clevertap.sendCleverTapEvent(key, payload);
        AnalyticsService.trackGtmEvent(gtmData);
      },
    });
  }
  componentWillUnmount() {
    this.props.resetCart();
  }

  handleBuyMembership = () => {
    const redirectLink = this.isLoggedInUser()
      ? '/co/payment'
      : '/login?redirectUrl=cart';
    history.push(redirectLink);
  };

  showPromoBox = () => {
    if (!this.isLoggedInUser()) {
      return this.props.setAppNotification(
        'Please login to apply promo coupons.'
      );
    }
    this.props.getPromoList();
    this.setState({ showPromoInput: !this.state.showPromoInput });
  };
  showReferralBox = () => {
    this.setState({ showReferralInput: !this.state.showReferralInput });
  };
  setPromo = ({ promoCode }) => {
    this.setState({ promoCode });
  };
  setReferral = ({ referralCode }) => {
    this.setState({ referralCode });
  };
  applyPromo = (promoCode = this.state.promoCode) => {
    this.props.applyPromoCode({
      promoCode,
      errorCb: errMsg => {
        this.setState({ invalidPromo: true, invalidPromoMsg: errMsg });
      },
      successCb: () => {
        const key = 'Select Promotion';
        const payload = {
          ...convertArrayToObject(this.props.cart.cartItems || []),
          cartItemTotalAmount:
            this.props.cart.priceDetails?.orderTotalAmount || 0,
          serviceAbleArea: this.props.launchInfo?.adcCode,
          customerType: this.props.launchInfo?.customerType,
          couponCode: promoCode,
        };
        clevertap.sendCleverTapEvent(key, payload);
        this.setState({
          invalidPromo: false,
          invalidPromoMsg: '',
          showPromoInput: false,
        });
      },
    });
  };
  removePromo = promoCode => {
    this.props.removePromoCode({ promoCode });
  };
  applyReferral = (referralCode = this.state.referralCode) => {
    this.props.applyReferralCode({
      referralCode,
      errorCb: errMsg => {
        this.setState({ invalidReferral: true, invalidReferralMsg: errMsg });
      },
      successCb: () => {
        this.setState({
          invalidReferral: false,
          invalidReferralMsg: '',
          showReferralInput: false,
        });
      },
    });
  };
  removeReferral = referralCode => {
    this.props.removeReferralCode({ referralCode });
  };
  nextActionCb = nextActionKey => {
    let nextRoute = getCheckoutRoute(nextActionKey);
    const gtmData = {
      eventName: 'beginCheckout',
      eventData: {
        category: 'checkout > start',
        action: nextActionKey,
      },
    };
    AnalyticsService.trackGtmEvent(gtmData);
    if (nextActionKey === 'addAddress') {
      const { latitude, longitude } = this.props.cart.deliveryAddress;
      console.log('Navigating to add new address: ', latitude, longitude);
      initializeMap({ coords: { latitude, longitude } });
      // history.push(nextRoute.replace('/:addressId?', ''));
      this.showAddressModal(true);
    } else if (nextActionKey === 'login') {
      this.props.showLoginModal(true);
      nextRoute = '/cart?redirectUrl=cart';
      history.push(nextRoute);
    } else if (
      nextActionKey === 'shipment' &&
      !this.props.cart?.deliveryAddress?.newAddress
    ) {
      history.push(nextRoute);
    }
  };
  onCtaAction = nextActionKey => {
    const hasSoldOutItems = this.props.cart?.cartItems?.filter(
      item => !item.invAvailable
    );
    if (hasSoldOutItems.length) {
      this.props.removeSoldoutItems({
        successCb: data => {
          if (!data.cartSoldOut) {
            this.nextActionCb(nextActionKey);
          }
        },
        failureCb: () =>
          this.props.setAppNotification(
            'Something went wrong. Please reload cart and try again.'
          ),
      });
    } else {
      this.nextActionCb(nextActionKey);
    }
  };

  getCartTitle = () => {
    const { cartQtyCount } = this.props;
    if (cartQtyCount === 1) return '1 item in cart';
    if (cartQtyCount > 1) return `${cartQtyCount} items in cart`;
    return 'Cart';
  };

  showAddressModal = value => {
    this.setState({ showAddressModal: value });
  };

  // cartCtaAction = cartCta => {
  //   console.log(cartCta);
  //   switch (cartCta) {
  //     case 'Complete Your Address':
  //       this.showAddressModal(true);
  //       break;
  //   }
  // };
  onAddonATC = product => {
    const successOpCb = msg => () => {
      this.props.setAppNotification(msg);
    };
    const failOpCb = msg => ({ errorMessage = msg }) => {
      if (errorMessage !== 'Please select a location.')
        this.props.setAppNotification(errorMessage);
    };
    this.props.postAddItem({
      ...product,
      successOpCb: successOpCb('Item added to cart'),
      failOpCb: failOpCb('Error adding item to cart'),
    });
  };

  render() {
    const {
      cart,
      postAddItem,
      postRemoveItem,
      completeAddressesList,
      randomSection,
      getRandomSection,
      promoList,
      mergeCartOnLoginModal,
    } = this.props;
    const { promoCodes, scratchCards } = promoList || {};
    let summary = {},
      promoDetails = null,
      referralDetails = null,
      showReferral = false;
    let cartCta = 'Complete Your Address';
    let nextActionKey = 'addAddress';
    if (!this.isLoggedInUser()) {
      cartCta = 'Login to place order';
      nextActionKey = 'login';
    }
    const changeAction = getCheckoutRoute('addressList');
    const sectionSource = 'CART';
    if (cart) {
      summary = cart.priceDetails;
      if (this.isLoggedInUser() && !cart?.deliveryAddress?.newAddress) {
        cartCta = 'Deliver to this address';
        nextActionKey = 'shipment';
      }
      if (
        (!cart.cartItems || cart.cartItems?.length === 0) &&
        (!randomSection || randomSection.sectionSource !== sectionSource)
      ) {
        getRandomSection({ sectionSource });
      }
      if (cart.promoDetails?.appliedpromoCode) {
        promoDetails = cart.promoDetails;
      }
      showReferral = cart.showReferral || false;
      if (cart.referralDetails?.appliedReferralCode) {
        referralDetails = cart.referralDetails;
      }
    }
    return (
      <Fragment>
        <div className="desktop-cart">
          {!mergeCartOnLoginModal && (
            <React.Fragment>
              {!cart && <Loader />}
              {cart?.cartItems?.length > 0 && (
                <React.Fragment>
                  <div className="desktop-cart--product-card-container">
                    <div className="desktop-cart--wrapper">
                      <div className="desktop-cart--title">
                        <div className="desktop-cart--title-text">CART</div>
                      </div>
                      {cart?.message && (
                        <Messages
                          type={cart?.message?.type}
                          webClassName="desktop-cart--title-message"
                          message={cart?.message?.description}
                          banner={true}
                        />
                      )}
                      {cart.addon && (
                        <div className="cart-addon-container">
                          <CartAddon
                            desktop
                            addon={cart.addon}
                            atcCb={this.onAddonATC}
                          />
                        </div>
                      )}
                      <MembershipBanner
                        containerStyle="desktop-cart-membership-banner"
                        showModal={() => this.setState({ showHbPrime: true })}
                        source="CART"
                        showCartMembershipDetails={cart?.membershipDetails}
                      />
                      {cart &&
                        cart.cartItems &&
                        cart.cartItems.map(item => {
                          return (
                            <div
                              className="desktop-plp--searchlist"
                              key={item.sku}
                            >
                              <ProductCard
                                // type="searchlist"
                                product={item}
                                onIncrement={postAddItem}
                                onDecrement={postRemoveItem}
                                cart
                                source="cart"
                              />
                            </div>
                          );
                        })}
                      <div className="section-divider"></div>
                    </div>
                    <div className="desktop-cart--details">
                      <div className="desktop-cart--referral-box">
                        {showReferral && !referralDetails && (
                          <div onClick={this.showReferralBox}>
                            <Messages
                              type="warning"
                              message="Apply referral code"
                              actionable={true}
                              actionText={
                                <Icon
                                  class="icon-common-yellow-arrow-right"
                                  size={10}
                                />
                              }
                              webClassName="desktop-cart--referral-box-font"
                              onAction={() => {}}
                            />
                          </div>
                        )}
                        {showReferral &&
                          referralDetails?.appliedReferralCode && (
                            <Messages
                              type="warning"
                              message={referralDetails.appliedReferralCode}
                              actionable={true}
                              actionText={
                                <Button className="button action-link desktop-cart--promo-box--remove-promo">
                                  Remove
                                </Button>
                              }
                              webClassName="desktop-cart--referral-box-font"
                              onAction={() =>
                                this.removeReferral(
                                  referralDetails.appliedReferralCode
                                )
                              }
                            />
                          )}
                      </div>
                      <div className="desktop-desktop-cart--promo-box">
                        {!promoDetails && (
                          <div onClick={this.showPromoBox}>
                            <Messages
                              type="success"
                              message="Apply coupon code"
                              actionable={true}
                              actionText={
                                <Icon
                                  class="icon-common-green-arrow-right"
                                  size={10}
                                />
                              }
                              webClassName="desktop-cart--promo-box-font"
                              onAction={() => {}}
                            />
                          </div>
                        )}
                        {promoDetails && (
                          <Messages
                            type="success"
                            message={promoDetails.appliedpromoCode}
                            actionable={true}
                            actionText={
                              <Button className="button action-link desktop-cart--promo-box--remove-promo">
                                Remove
                              </Button>
                            }
                            webClassName="desktop-cart--promo-box-font"
                            onAction={() =>
                              this.removePromo(promoDetails.appliedpromoCode)
                            }
                          />
                        )}
                      </div>
                      {cart?.amountSavedMessage && (
                        <div
                          className="shaking-animation"
                          key={cart?.amountSavedMessage}
                        >
                          <Messages
                            message={cart?.amountSavedMessage}
                            webClassName="desktop-save-amount--container"
                            icon={giftIcon}
                            messageStyle="desktop-save-amount--text"
                            iconStyle="desktop-save-amount--img"
                          />
                        </div>
                      )}
                      <CartSummary
                        summaryOrder={cart?.summaryOrder}
                        showHbPointsModal={() =>
                          this.setState({ showHbPointsModal: true })
                        }
                      />
                      <div className="section-divider--white"></div>
                      <div className="desktop-cart--address-detail">
                        <div className="desktop-cart--address-detail--address">
                          <Icon
                            size={30}
                            class="icon-location-bar-location-marker flex-shrink-0"
                          />
                          <div className="desktop-cart--address-detail--primary-text ellipsis">
                            {cart.deliveryAddress.addressType ||
                              cart.deliveryAddress.area}
                          </div>
                          {completeAddressesList?.length > 0 && (
                            <Link
                              to="#"
                              onClick={() => {
                                this.props.showAddressListModal(true);
                                getCheckoutRoute('addressList');
                              }}
                              className="desktop-order-details--highlights--invoice
                              desktop-cart--address-detail--change-link
                              button action-link more"
                            >
                              Change
                            </Link>
                          )}
                        </div>
                        <div className="desktop-cart--address-detail--secondary-text">
                          {cart.deliveryAddress.addressLine1 ||
                            cart.deliveryAddress.mapLocation ||
                            cart.deliveryAddress.addressLine2}
                        </div>
                      </div>
                      <div className="">
                        <Button
                          className="button button-primary full-width large"
                          onClick={() => this.onCtaAction(nextActionKey)}
                        >
                          {cartCta}
                        </Button>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              )}
              {cart && (!cart.cartItems || cart.cartItems?.length === 0) && (
                <div className="desktop-cart--empty-cart-container">
                  {!cart?.membershipDetails?.isMembershipAdded && (
                    <div className="desktop-cart--empty-cart-left">
                      <div className="desktop-cart--empty-cart-icon">
                        <Icon class="icon-cart-empty-cart" size={241} />
                      </div>
                      <div className="desktop-cart--empty-cart-oops">
                        Whoops!
                      </div>
                      <div className="desktop-cart--empty-cart-msg">
                        Your cart is empty.
                        <div className="desktop-cart--empty-cart-sub-msg">
                          Looks like you haven’t made up your mind yet.
                        </div>
                      </div>
                      <div className="desktop-cart--empty-cart-cta">
                        <Link
                          to="/"
                          className="button button-primary desktop-cart--empty-cart-cta-btn-width large"
                        >
                          View Products
                        </Link>
                      </div>
                    </div>
                  )}
                  {cart?.membershipDetails?.isMembershipAdded && (
                    <div className="desktop-cart--empty-cart-width">
                      {cart.message && (
                        <Messages
                          type={cart.message.type}
                          webClassName="desktop-cart--title-message"
                          message={cart.message.description}
                          banner={true}
                        />
                      )}
                      {cart?.amountSavedMessage && (
                        <div
                          className="shaking-animation"
                          key={cart?.amountSavedMessage}
                        >
                          <Messages
                            message={cart?.amountSavedMessage}
                            webClassName="desktop-save-amount--container"
                            icon={giftIcon}
                            messageStyle="desktop-save-amount--text"
                            iconStyle="desktop-save-amount--img"
                          />
                        </div>
                      )}
                      <div className="cart--summary-alignment ">
                        <CartSummary
                          summaryOrder={cart?.summaryOrder}
                          showHbPointsModal={() =>
                            this.setState({ showHbPointsModal: true })
                          }
                        />
                      </div>
                      <div className="desktop-cart--membership-button">
                        <Button
                          className="button button-primary full-width large"
                          onClick={() => this.handleBuyMembership()}
                        >
                          {BUY_MEMBERSHIP}
                        </Button>
                      </div>
                    </div>
                  )}
                  <div className="desktop-cart--empty-cart-right">
                    <MembershipBanner
                      containerStyle="desktop-cart-membership-banner-add"
                      showModal={() => this.setState({ showHbPrime: true })}
                      source="CART"
                      showCartMembershipDetails={cart?.membershipDetails}
                    />
                    {randomSection && (
                      <Deals
                        products={randomSection.products}
                        title={randomSection.title}
                        showSoldOut={false}
                        source="cart"
                      />
                    )}
                  </div>
                </div>
              )}
            </React.Fragment>
          )}
          <Drawer
            visible={this.state.showHbPrime}
            placement="right"
            closable={false}
            onClose={() =>
              this.setState({
                showHbPrime: false,
              })
            }
            destroyOnClose={true}
            maskClosable={false}
            width={500}
            className="hb-prime-drawer"
          >
            <div>
              <HalalboxPrime
                source="CART"
                onCancel={() =>
                  this.setState({
                    showHbPrime: false,
                  })
                }
              />
            </div>
          </Drawer>
          <Drawer
            title="APPLY PROMO CODE"
            visible={this.state.showPromoInput}
            placement="right"
            closable={true}
            onClose={() =>
              this.setState({
                showPromoInput: false,
                invalidPromo: false,
                invalidPromoMsg: '',
              })
            }
            destroyOnClose={true}
            maskClosable={false}
            width={500}
            footer={
              <Button
                className="button button-primary full-width large flex-shrink-0"
                onClick={() => this.applyPromo()}
                disabled={!this.state.promoCode?.length}
              >
                Apply
              </Button>
            }
          >
            <Input
              type="text"
              onChange={this.setPromo}
              name="promoCode"
              className="desktop-promo-list--apply-promo flex-shrink-0"
              placeholder="Add promo code"
              maxLength={50}
              value={this.state.promoCode}
              hasError={this.state.invalidPromo}
              errorMsg={this.state.invalidPromoMsg}
              autoFocus={false}
            />

            {(scratchCards?.unscratched?.length > 0 ||
              scratchCards?.scratched?.length > 0) && (
              <>
                <div className="desktop-promo-list--header flex-shrink-0">
                  {scratchCards?.title || WEDNESDAY_COUPONS}
                </div>
                {scratchCards?.unscratched?.length > 0 && (
                  <div className="desktop-scratch-card--unscratch-container">
                    {scratchCards?.unscratched?.map(item => (
                      <div
                        key={item.id}
                        className="desktop-scratch-card--unscratch-card"
                        onClick={() => {
                          const payload = {
                            visible: true,
                            source: 'cart',
                            data: item,
                          };
                          this.props.showScratchCardModal(payload);
                        }}
                      >
                        <img
                          src={item?.foregroundUrl}
                          className="desktop-scratch-card--image"
                        />
                      </div>
                    ))}
                  </div>
                )}

                {scratchCards?.scratched?.length > 0 && (
                  <div style={{ marginTop: 25 }}>
                    <ListComponent
                      list={scratchCards?.scratched}
                      isScratchCard={true}
                      applyPromo={this.applyPromo}
                    />
                  </div>
                )}
                <div className="section-divider" />
              </>
            )}

            {promoCodes?.codes?.length > 0 && (
              <>
                <div className="desktop-promo-list--header flex-shrink-0">
                  {promoCodes?.title || AVAILABLE_COUPONS}
                </div>
                <ListComponent
                  list={promoCodes?.codes}
                  applyPromo={this.applyPromo}
                />
              </>
            )}
          </Drawer>
          <Drawer
            title="APPLY REFERRAL CODE"
            visible={this.state.showReferralInput}
            placement="right"
            closable={true}
            onClose={() =>
              this.setState({
                showReferralInput: false,
                invalidReferral: false,
                invalidReferralMsg: '',
              })
            }
            footer={
              <Button
                className="button button-primary full-width large flex-shrink-0"
                onClick={() => this.applyReferral()}
                disabled={!this.state.referralCode?.length}
              >
                Apply Referral
              </Button>
            }
            destroyOnClose={true}
            maskClosable={false}
            width={500}
          >
            <Input
              type="text"
              onChange={this.setReferral}
              name="referralCode"
              className="desktop-promo-list--apply-promo flex-shrink-0"
              placeholder="Add referral code"
              maxLength={50}
              value={this.state.referralCode}
              hasError={this.state.invalidReferral}
              errorMsg={this.state.invalidReferralMsg}
              autoFocus={false}
            />
          </Drawer>
        </div>
        {this.state.showAddressModal && (
          <AddAddress
            prefix="co"
            actionType="new"
            addressId={null}
            showModal={this.showAddressModal}
          />
        )}
        {this.state.showHbPointsModal && (
          <SimpleModal
            visible={this.state.showHbPointsModal}
            title="VXL Points"
            wrapClassName="desktop-cart--hb-points-modal"
            onCancel={() => this.setState({ showHbPointsModal: false })}
          >
            <span>
              VXL Points is automatically deducted.
              <br />
              No need to apply.
            </span>
          </SimpleModal>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  cartReducer,
  productReducer,
  initialReducer,
  modalReducer,
}) => ({
  cart: cartReducer.cart,
  cartQtyCount: cartReducer.cartQtyCount,
  cartLoading: cartReducer.cartLoading,
  completeAddressesList: cartReducer.completeAddressesList,
  randomSection: productReducer.randomSection,
  promoList: cartReducer.promoList,
  loggedInState: initialReducer.launchInfo.loggedIn,
  mergeCartOnLoginModal: modalReducer.mergeCartOnLoginModal,
  loginModal: modalReducer.loginModal,
  launchInfo: initialReducer.launchInfo,
});
const mapDispatchToProps = {
  showCart,
  resetCart,
  postAddItem,
  getPromoList,
  postRemoveItem,
  applyPromoCode,
  removePromoCode,
  applyReferralCode,
  removeReferralCode,
  setAppNotification,
  getRandomSection,
  removeSoldoutItems,
  showLoginModal,
  showAddressListModal,
  showScratchCardModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
